import React from 'react';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import DigitalTranslationsResults from './DigitalTranslationsResults';
import SubmitDigitalTranslationForm from './SubmitDigitalTranslationForm';
var ManageDigitalTranslations = function ManageDigitalTranslations(_ref) {
  var digitalTranslationsEnabled = _ref.digitalTranslationsEnabled,
    digitalTranslations = _ref.digitalTranslations,
    createDigitalOrder = _ref.createDigitalOrder,
    getDownloadUrl = _ref.getDownloadUrl,
    fileIdentity = _ref.fileIdentity,
    initialLanguageSelection = _ref.initialLanguageSelection,
    pagination = _ref.pagination,
    paginationUrl = _ref.paginationUrl,
    searchDigitalOrders = _ref.searchDigitalOrders,
    status = _ref.status,
    updateDisplayedDigitalOrders = _ref.updateDisplayedDigitalOrders,
    uuid = _ref.uuid,
    wordCountExceeded = _ref.wordCountExceeded;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "your-digital-translations"
  })), wordCountExceeded ? /*#__PURE__*/React.createElement("div", {
    className: "digital-translations-upload-disabled alert alert-warning clearfix mt-2"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-word-count-exceeded",
    params: {
      fileIdentity: fileIdentity
    }
  })) : null, digitalTranslationsEnabled ? /*#__PURE__*/React.createElement(SubmitDigitalTranslationForm, {
    createDigitalOrder: createDigitalOrder,
    initialLanguageSelection: initialLanguageSelection,
    uuid: uuid
  }) : /*#__PURE__*/React.createElement("div", {
    className: "digital-translations-upload-disabled alert alert-warning clearfix mt-2"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/researcher/digital-translations/purchase",
    className: "btn btn-primary float-end ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Subscribe"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-instructions-none"
  })), digitalTranslations.length > 0 ? /*#__PURE__*/React.createElement(DigitalTranslationsResults, {
    digitalTranslations: digitalTranslations,
    getDownloadUrl: getDownloadUrl,
    pagination: pagination,
    paginationUrl: paginationUrl,
    searchDigitalOrders: searchDigitalOrders,
    status: status,
    updateDisplayedDigitalOrders: updateDisplayedDigitalOrders
  }) : /*#__PURE__*/React.createElement("div", {
    className: "no-results bg-light border mt-3 p-5 text-secondary text-center text-small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translations-completed-appear-here"
  })));
};
export default ManageDigitalTranslations;